import { toast } from 'sonner'
import { formatCurrency } from '@/utils/format-currency'
import { formatNegotiationDeadlineSlideLabel } from '@/utils/negotiationDeadline'
import {
  formatSupportHoursSlideLabel,
  resolveSupportHoursForSlide,
  resolveSupportTierSlideLines,
} from '@/utils/planSuportePricing'
import { saveProposalPresentation } from '@/utils/proposalPresentationSnapshot'
import type { useProposalStudio } from './useProposalStudio'

type Studio = Pick<
  ReturnType<typeof useProposalStudio>,
  | 'deal'
  | 'activePlan'
  | 'catalogPlans'
  | 'layout'
  | 'showPricing'
  | 'comboPriceFrom'
  | 'activeServiceGroups'
>

/** Abre a apresentação no navegador com o plano que está na tela. */
export function openStudioPresentation(s: Studio) {
  const plan = s.activePlan
  if (!plan) {
    toast.error('Monte o plano antes de apresentar')
    return
  }

  const showPricing = s.showPricing
  saveProposalPresentation({
    empresaNome: s.deal.empresaNome || 'Cliente',
    value: {
      layout: s.layout,
      planName: plan.descricao || plan.nome || '',
      planDescription: plan.description || '',
      supportHoursLabel: formatSupportHoursSlideLabel(
        resolveSupportHoursForSlide(plan, s.catalogPlans),
      ),
      supportTierLines: resolveSupportTierSlideLines(plan, s.catalogPlans),
      planTipo: plan.tipo || 'plano',
      projectType: plan.projectType,
      planValue: showPricing ? plan.pricing?.installmentValue ?? plan.valorUnitario ?? 0 : 0,
      isRecurring: true,
      hidePricing: !showPricing,
      priceCompareFrom: showPricing ? s.comboPriceFrom : undefined,
      paymentDetails:
        showPricing && !plan.pricing?.recorrente
          ? `${plan.pricing?.installments || 1}x de ${formatCurrency(plan.pricing?.installmentValue || plan.valorUnitario)}`
          : '',
      loyaltyDuration: showPricing
        ? plan.pricing?.recorrente
          ? `Fidelidade: ${plan.duration || 12} meses`
          : `Duração: ${plan.duration || 1} meses`
        : '',
      negotiationDeadlineLabel: showPricing
        ? formatNegotiationDeadlineSlideLabel(plan.negotiationValidUntil)
        : '',
      bonusText: showPricing && plan.showBonus === true ? plan.bonus || '' : '',
      serviceGroups: [...s.activeServiceGroups.entries()],
    },
  })

  const opened = window.open('/apresentacao', '_blank', 'noopener')
  if (!opened) toast.error('O navegador bloqueou a nova aba. Permita abrir a apresentação.')
}
